import styled from '@emotion/styled'
import { mediaQueries } from '@lib/mediaQueries'

export const Row = styled.div({
  textAlign: 'center',
  display: 'block',
  flexShrink: 0,
  width: '100%',

  '&:not(:first-of-type)': {
    marginTop: '2rem',
  },
})

export const Container = styled.div(
  mediaQueries({
    alignContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: 'auto',
    paddingTop: ['2rem', '2rem', 0],
    width: ['100%', '100%', '90%', '80%', '70%'],
  })
)
